import { render, staticRenderFns } from "./KBookingModalReminder.vue?vue&type=template&id=213baeb9&lang=pug&"
import script from "./KBookingModalReminder.vue?vue&type=script&lang=js&"
export * from "./KBookingModalReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import KBookingCardConfirmed from '@/components/app/Booking/Card/KBookingCardConfirmed.vue'
import KCardModal from '@/components/shared/Card/KCardModal.vue'
import KCardText from '@/components/shared/Card/KCardText.vue'
installComponents(component, {KBookingCardConfirmed,KCardModal,KCardText})
